module.exports = __webpack_public_path__ + "static/media/icon-notify-success.f1e50c61.svg";